
import { useState } from 'react';
import { toast } from 'sonner';
import { useShare } from '@/hooks/useShare';

export const useInviteCodeActions = (inviteCode: string | null) => {
  const [codeCopied, setCodeCopied] = useState(false);
  const [isSharing, setIsSharing] = useState(false);
  const { shareInviteCode, canShare } = useShare();
  
  const copyInviteCode = () => {
    if (inviteCode) {
      navigator.clipboard.writeText(inviteCode);
      setCodeCopied(true);
      toast.success('Invite code copied to clipboard');
      setTimeout(() => setCodeCopied(false), 2000);
    }
  };

  const handleShareInviteCode = async () => {
    if (!inviteCode || !canShare) return;
    
    setIsSharing(true);
    try {
      await shareInviteCode(inviteCode);
    } finally {
      setIsSharing(false);
    }
  };

  return {
    codeCopied,
    isSharing,
    copyInviteCode,
    handleShareInviteCode,
    canShare: canShare && !!inviteCode
  };
};
